import Cookie from '../_00_elements/tools/cookie';
import Logger from '../_00_elements/tools/logger/logger';
import Storage from '../_00_elements/tools/storage/storage';
import momentMixin from '../_00_elements/tools/moment';

import { ORIGIN_FAVORITE, UserOrigin } from '../_00_elements/tools/user/origin';
import { URL_OFFER_FAVORITE_SET } from '../_00_elements/tools/routes/routes';
import { KEY_USER_CALLBACK } from '../_00_elements/tools/storage/keys';
import { FAVORITE_PROPOSAL_EVENT } from './constants';
import eventBus from '../_00_elements/tools/event-bus';
import type { OfferTeamSize } from '../model/offer';

/**
 * Store requested offer id, so we'll be able to
 * save it upon login/registration and trigger login tunnel
 */
export function storeCallbackAndDoLogin(
  favorite: boolean,
  hashId: string,
): void {
  const storage = new Storage(Cookie);
  storage.setJSON(
    KEY_USER_CALLBACK,
    {
      callbackEvent: 'favorite',
      favorite,
      offerId: hashId,
    },
    1 / 144,
  );
  eventBus.dispatchEvent(new Event('close-modal'));
  UserOrigin.set(ORIGIN_FAVORITE, { offer_id: hashId });
  eventBus.dispatchEvent(new CustomEvent('start-entry-tunnel', { detail: window.location.href }));
}

interface CallSetFavoriteApiParams {
    detail: {
        offerHashId: string,
        isActive: boolean,
        offerTeamSizes?: OfferTeamSize[],
        teamSize?: number,
    };
}

async function callSetFavoriteApi({
  detail: { offerHashId, isActive, offerTeamSizes, teamSize },
}: CallSetFavoriteApiParams): Promise<void> {
  try {
    const response = await fetch(URL_OFFER_FAVORITE_SET.replace('{id}', offerHashId), {
      method: 'POST',
      body: JSON.stringify({
        favorite: isActive,
        offerTeamSizes,
        teamSize,
      }),
    });

    if (response.status === 401) {
      storeCallbackAndDoLogin(isActive, offerHashId);
      return;
    }

    if (!response.ok) {
      throw new Error('Favorite backend call, response nok');
    }

    const { favorite }: { favorite: boolean } = await response.json();

    eventBus.dispatchEvent(new CustomEvent(FAVORITE_PROPOSAL_EVENT.OFFER_FAVORITE_TOGGLE_CALLBACK, {
      detail: { offerHashId, favorite },
    }));
  } catch (error) {
    Logger.error(error);
  }
}

const init = (): void => {
  eventBus.addEventListener(FAVORITE_PROPOSAL_EVENT.OFFER_FAVORITE_TOGGLE, callSetFavoriteApi);
};

export default init;
